'use client';

import { ErrorBoundary } from '@sentry/react';
import { Button } from '@tremor/react';
export default function GlobalErrorBoundary({
  children
}: {
  children: React.ReactNode;
}) {
  return <ErrorBoundary fallback={({
    error,
    resetError
  }) => {
    return <div className='absolute inset-0 bg-white text-black flex flex-col items-center justify-center p-8 z-50'>
            <h1 className='text-3xl font-bold mb-4'>
              Oops! Something went wrong.
            </h1>
            <p className='mb-6 w-11/12 md:w-2/3 lg:w-1/2 xl:w-2/5 text-xs'>
              An error occurred, Please try again.
            </p>
            <Button onClick={() => resetError()} className='bg-black text-white px-6 py-3 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-300'>
              Go Back
            </Button>
          </div>;
  }} data-sentry-element="ErrorBoundary" data-sentry-component="GlobalErrorBoundary" data-sentry-source-file="global-error.tsx">
      {children}
    </ErrorBoundary>;
}